<template>
    <div>
        <div class="content has-text-centered">
            <img src="/img/resize_logo.png" class="has-text-centered language-image logo-bottom-margin" >
        </div>
        <div class="columns">
            <div 
            v-for="(language, languageMenuIndex) in languages"
            v-bind:key="languageMenuIndex"
            class="column has-text-centered">
                <img :src="'/img/flags/'+language+'.png'" class="language-image shadow" @click="changeLanguage(language)" />
            </div>
        </div>
        <div class="up-margin">
            <b-button 
                v-for="(item, itemMenuIndex) in items"
                v-bind:key="itemMenuIndex"
                tag="router-link"
                :to="item == 'homepage' ? '/' : '/'+item"
                :class="[$route.name == item ? 'is-fullwidth is-active' : 'is-fullwidth shadow']">
                {{ $t("menu."+item) }}
            </b-button>
        </div>
        <div class="content has-text-centered footer-top-margin">
            <div>
                Copyright &copy; {{ new Date().getFullYear() }}
                <a href="https://www.feralheart.dev" target="_blank">
                    <img src="/img/horizontal_logo.png" class="has-text-centered language-image" >
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["languages", "items"],
        methods: {
            changeLanguage(lang){
                this.$Progress.start()
                this.$i18n.locale = lang
                this.$Progress.finish()
            }
        }
    }
</script>